import { Datepicker } from 'components/form/Datepicker';
import { ConfirmationModal } from 'components/modals/ConfirmationModal';
import { Toaster } from 'components/notification/Toaster';
import { func_validation } from 'functions';
import React, { useEffect, useState } from 'react';

export function useGenerateInvoice(props) {
    const {
        selectedBillingSetup,
        generateInvoice_status, generateInvoice_requesting,
        isModalResetRequired
    } = props;

    const [isModalVisible_generateInvoice, setIsModalVisible_generateInvoice] = useState(false);
    const [generateInvoice_endDate, setGenerateInvoice_endDate] = useState("");

    function validateOnInvoiceGeneration(selectedAccounts) {
        if (func_validation.isArrayNotEmpty(selectedAccounts)) {
            setIsModalVisible_generateInvoice(true);
            if (func_validation.isFunction(props.setSelectedBillingSetup)) 
                props.setSelectedBillingSetup(selectedAccounts);
        }
        else {
            Toaster({
                type: "info",
                msg: "Please select at least 1 row.",
            });
        }
    }
    function handleAccount_generateInvoice() {
        if (func_validation.isArrayNotEmpty(selectedBillingSetup)) {
            selectedBillingSetup.map((billingSetup) => {
                let accountCode = func_validation.getObjectPropertyValue(billingSetup, "AccountCode");

                if (func_validation.isStringTrimNotEmpty(accountCode) &&
                    props.generateInvoice)
                    props.generateInvoice(accountCode, generateInvoice_endDate);
            });
        }
    }

    useEffect(() => {
        if (func_validation.isFunction(props.resetModalState)) 
            props.resetModalState();
    }, [isModalVisible_generateInvoice]);

    let generateInvoiceModal = (
        <ConfirmationModal
            description={"The selected billing setup(s) will be generated into invoice(s)."}

            input={(
                <Datepicker
                    label={"End Date: "}
                    handleOnChange={setGenerateInvoice_endDate}

                    isResetRequired={isModalResetRequired}
                    isConversionRequired_ISO8601
                />
            )}
            
            cancelButtonText={"Cancel"}
            confirmButtonText={"Confirm"}
            isModalVisible={isModalVisible_generateInvoice}
            updateParentState={setIsModalVisible_generateInvoice}
            handleOnConfirm={handleAccount_generateInvoice}
            isActionLoading={generateInvoice_requesting}
            isConfirmSuccessful={generateInvoice_status}
        />
    );
    
    return {
        validateOnInvoiceGeneration,
        handleAccount_generateInvoice,
        isModalVisible_generateInvoice,
        generateInvoiceModal,
        setGenerateInvoice_endDate
    }
}